import { inject, Injectable } from '@angular/core';

import { BeehiveApiService } from '../beehive-api.service';
import { Customer } from './customer.model';
import { Child } from '../child/child.model.js';
import { forkJoin, map, mergeMap, Observable } from 'rxjs';
import { ChildService } from '../child/child.service.js';
import { Document } from '../document/document.model';
import { AdminRole, StaffRole } from '../staff/lib/staff.interfaces';
import { Staff } from '../staff/staff.model';

@Injectable({ providedIn: 'root' })
export class CustomerService extends BeehiveApiService<Customer> {
  protected entityType = Customer;
  protected endpoint = 'customers';

  private readonly childService = inject(ChildService);

  getChildren(customer: Customer) {
    return this.getMany(
      [encodeURIComponent(customer.id), 'children'],
      undefined,
      Child,
    );
  }

  getCustomerRegistrations(customer: Customer) {
    return this.getChildren(customer).pipe(
      mergeMap((children) =>
        forkJoin(
          children.map((child) => this.childService.getRegistrations(child)),
        ),
      ),
      map((registrations) => registrations.flat()),
    );
  }

  getCustomerDocuments(customer: Customer) {
    return this.getMany(
      [encodeURIComponent(customer.id), 'documents'],
      undefined,
      Document,
    );
  }

  promote(
    customer: Customer,
    staffRoles: StaffRole[],
    adminRoles: AdminRole[],
  ): Observable<Staff> {
    return this.post([customer.id, 'promote'], {
      staffRoles,
      adminRoles,
    });
  }
}
